import { useTranslation } from "react-i18next";
// Components
import {
  TrainingDiv,
  TitleTextDiv,
  DataDiv,
  ColumnDataDiv,
  InputDataDiv,
  Label,
  HandRaisingCapacityImgDiv,
  HandRaisingCapacityImg,
} from "./styles";
import Select from "../../../selectInput";
// Assets
import SelectArrow from "../../../../assets/icons/ico_arrow_down.svg";
import BothLowArmImg from "../../../../assets/images/patients/both_arms_low_height.png";
import BothMediumArmImg from "../../../../assets/images/patients/both_arms_medium_height.png";
import BothHighArmImg from "../../../../assets/images/patients/both_arms_high_height.png";
import LeftLowArmImg from "../../../../assets/images/patients/left_arm_low_height.png";
import LeftMediumArmImg from "../../../../assets/images/patients/left_arm_medium_height.png";
import LeftHighArmImg from "../../../../assets/images/patients/left_arm_high_height.png";
import RightLowArmImg from "../../../../assets/images/patients/right_arm_low_height.png";
import RightMediumArmImg from "../../../../assets/images/patients/right_arm_medium_height.png";
import RightHighArmImg from "../../../../assets/images/patients/right_arm_high_height.png";

const Training = ({
  upperExtremityToTrain,
  setUpperExtremityToTrain,
  handRaisingCapacity,
  setHandRaisingCapacity,
  cognitiveFunctionLevel,
  setCognitiveFunctionLevel,
}) => {
  const [t] = useTranslation("global");

  const renderHandsRaisingCapacityImg = () => {
    const ARM_IMAGES = {
      BOTH: {
        LOW: BothLowArmImg,
        MEDIUM: BothMediumArmImg,
        HIGH: BothHighArmImg,
      },
      LEFT: {
        LOW: LeftLowArmImg,
        MEDIUM: LeftMediumArmImg,
        HIGH: LeftHighArmImg,
      },
      RIGHT: {
        LOW: RightLowArmImg,
        MEDIUM: RightMediumArmImg,
        HIGH: RightHighArmImg,
      },
    };
    return ARM_IMAGES[upperExtremityToTrain][handRaisingCapacity];
  };

  return (
    <TrainingDiv>
      <TitleTextDiv>
        <p>{t("patientTraining_title")}</p>
      </TitleTextDiv>
      <DataDiv>
        <ColumnDataDiv width="385px">
          <InputDataDiv>
            <Label fontWeight="bold">{t("patientTraining_upperExtremityLabel")} *</Label>
            <Select
              value={upperExtremityToTrain}
              onChange={(e) => setUpperExtremityToTrain(e.target.value)}
              padding="5px 35px 5px 10px"
              width="200px"
              arrowImg={SelectArrow}
              backgroundPosition="175px center"
            >
              <option value="LEFT">{t("patientTraining_upperExtremityToTrain_left")}</option>
              <option value="RIGHT">{t("patientTraining_upperExtremityToTrain_right")}</option>
            </Select>
          </InputDataDiv>
          <InputDataDiv>
            <Label fontWeight="bold">{t("patientTraining_gravityTrainingLabel")} *</Label>
            <Select
              value={handRaisingCapacity}
              onChange={(e) => setHandRaisingCapacity(e.target.value)}
              padding="5px 35px 5px 10px"
              width="200px"
              arrowImg={SelectArrow}
              backgroundPosition="175px center"
            >
              <option value="NONE">{t("no")}</option>
              {handRaisingCapacity === "NONE" && <option value="LOW">{t("yes")}</option>}
              {handRaisingCapacity === "LOW" && <option value="LOW">{t("yes")}</option>}
              {handRaisingCapacity === "MEDIUM" && <option value="MEDIUM">{t("yes")}</option>}
              {handRaisingCapacity === "HIGH" && <option value="HIGH">{t("yes")}</option>}
            </Select>
          </InputDataDiv>
          {handRaisingCapacity !== "NONE" && (
            <InputDataDiv activeAnimation>
              <Label fontWeight="bold">{t("patientTraining_handRaisingCapacityLabel")} *</Label>
              <Select
                value={handRaisingCapacity}
                onChange={(e) => setHandRaisingCapacity(e.target.value)}
                padding="5px 35px 5px 10px"
                width="200px"
                arrowImg={SelectArrow}
                backgroundPosition="175px center"
              >
                <option value="LOW">{t("patientTraining_handRaisingCapacity_low")}</option>
                <option value="MEDIUM">{t("patientTraining_handRaisingCapacity_medium")}</option>
                <option value="HIGH">{t("patientTraining_handRaisingCapacity_high")}</option>
              </Select>
            </InputDataDiv>
          )}
        </ColumnDataDiv>
        <ColumnDataDiv width="385px">
          <InputDataDiv>
            <Label fontWeight="bold">{t("patientTraining_cognitiveFunctionLevelLabel")} *</Label>
            <Select
              value={cognitiveFunctionLevel}
              onChange={(e) => setCognitiveFunctionLevel(e.target.value)}
              padding="5px 35px 5px 10px"
              width="200px"
              arrowImg={SelectArrow}
              backgroundPosition="175px center"
            >
              <option value="LOW">{t("patientTraining_cognitiveFunctionLevel_low")}</option>
              <option value="LOW_MEDIUM">{t("patientTraining_cognitiveFunctionLevel_low_medium")}</option>
              <option value="MEDIUM">{t("patientTraining_cognitiveFunctionLevel_medium")}</option>
              <option value="MEDIUM_HIGH">{t("patientTraining_cognitiveFunctionLevel_medium_high")}</option>
              <option value="HIGH">{t("patientTraining_cognitiveFunctionLevel_high")}</option>
            </Select>
          </InputDataDiv>
          {handRaisingCapacity !== "NONE" && (
            <HandRaisingCapacityImgDiv>
              <HandRaisingCapacityImg src={renderHandsRaisingCapacityImg()} alt="hand-raising-capacity-img" />
            </HandRaisingCapacityImgDiv>
          )}
        </ColumnDataDiv>
      </DataDiv>
    </TrainingDiv>
  );
};

export default Training;
